export function lookupPublisher(source: string | null): string | null {
  if (!source) return "Unknown Publisher";

  const publisherMap: Record<string, string> = {
    litetracks: "Loop Community - Lite",
    premiumtracks: "Loop Community - Premium",
    worshipzonetracks: "WorshipZone",
  };

  return publisherMap[source] || source || "Unknown Publisher" || null;
}
